<!-- Plans.vue -->
<template>
  <div>
    <Header :showInput="false" />
    <div class="pricing_block">
      <div class="container">
        <div class="pricing_header">
          <h2 class="header_sublvl">{{ $t('PRC_HEADER') }}</h2>
          <div class="types_change">
            <span class="active">
              {{ $t('PRC_YEAR') }}
              <u>{{ $t('PRC_DSCNT') }} 15%</u>
            </span>
            <span>{{ $t('PRC_MNTH') }}</span>
          </div>
        </div>
        <div class="pricing_body">
          <PricingPlan v-for="plan in plans" :key="plan.name" :plan="plan" :period="$t('PRC_PRD')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import PricingPlan from './PricingPlan.vue';

export default {
  components: {
    Header,
    PricingPlan
  },
  data() {
    return {
      plans: [
        { name: "Basic", popular: false, api: "--", accessCount: "0", pageCount: 2, retrospective: "last 14 days", autoReports: "--", price: "$0" },
        { name: "Starter", popular: false, api: "--", accessCount: "0", pageCount: 30, retrospective: "365 days", autoReports: "--", price: "$7" },
        { name: "Pro", popular: true, api: "--", accessCount: "2", pageCount: 30, retrospective: "5 years", autoReports: "Yes", price: "$15" },
        { name: "Enterprise", popular: false, api: "Yes", accessCount: "2", pageCount: 30, retrospective: "5 years", autoReports: "Yes", price: "$90" }
      ]
    };
  }
};
</script>